import type { RadioGroupCustomEvent } from '@ionic/react'
import { ComponentProps } from 'react'
import { Controller } from 'react-hook-form'
import { useParserI18nMessage } from '~/shared/lib/i18n'
import { IonRadioGroup, IonRadio } from './styled'

type Option = { id: UniqueId; label: string }

type RadioGroupProps = {
  name: string
  options: Option[]
} & ComponentProps<typeof IonRadioGroup>

const compareWith = (groupId: UniqueId, itemId: UniqueId) => {
  return groupId === itemId
}

export function RadioGroup({ name, options, ...groupProps }: RadioGroupProps) {
  const { parserI18nMessage } = useParserI18nMessage()

  return (
    <Controller
      name={name}
      defaultValue=''
      render={({ field: { onChange, value } }) => {
        return (
          <IonRadioGroup
            name={name}
            value={value}
            compareWith={compareWith}
            onIonChange={(e: RadioGroupCustomEvent) => {
              onChange(e.detail.value)
            }}
            {...groupProps}
          >
            {options.map(({ id, label }) => (
              <IonRadio
                mode='md'
                key={id}
                value={id}
                labelPlacement='end'
                justify='start'
              >
                {parserI18nMessage(label)}
              </IonRadio>
            ))}
          </IonRadioGroup>
        )
      }}
    />
  )
}
